import { Injectable } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ApiClientService {

    constructor(private http: HttpClient) { }

    get<T>(uri: string) {
        return this.http.get<T>(AppSettings.API_ENDPOINT + uri);
    }

    post(uri: string, body: any) {
        return this.http.post(AppSettings.API_ENDPOINT + uri, body);
    }

    put(uri: string, body: any) {
        return this.http.put(AppSettings.API_ENDPOINT + uri, body);
    }

    delete(uri: string) {
        return this.http.delete(AppSettings.API_ENDPOINT + uri);
    }
    getWithoutUri(uri: string) {
        return this.http.get( uri);
    }

}
